import { Component } from '@verndale/core';
import { v4 as uuidv4 } from 'uuid';
import { keyCode } from '../helpers';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      tabs: this.el.querySelectorAll('[role=tab]'),
      panels: this.el.querySelectorAll('[role=tabpanel]'),
      tabLink: this.el.querySelector('.about-us-tabs__view-all a')
    };

    this.addIds();
  }

  addListeners() {
    this.dom.tabs.forEach((tab, index) => {
      tab.addEventListener('click', e => this.handleTabActivation(e, index));
      tab.addEventListener('keyup', this.handleTabKeyUp.bind(this));
    });
  }

  addIds() {
    const id = uuidv4();

    if (this.dom.tabs.length !== this.dom.panels.length) {
      console.warn(
        `The number of tabs (${this.dom.tabs.length}) and panels (${this.dom.panels.length}) are different`
      );
    }

    this.dom.tabs.forEach((tab, index) => {
      tab.id = `tab-${id}-${index}`;
      tab.setAttribute('aria-controls', `panel-${id}-${index}`);
    });

    this.dom.panels.forEach((panel, index) => {
      panel.id = `panel-${id}-${index}`;
      panel.setAttribute('aria-labelledby', `tab-${id}-${index}`);
    });
  }

  handleTabActivation(e, index) {
    const { tabLinkLabel, tabLinkUrl } = e.currentTarget.dataset;
    this.dom.tabLink.setAttribute('href', tabLinkUrl || '');
    this.dom.tabLink.textContent = tabLinkLabel;

    // activate tab
    this.dom.tabs.forEach((tab, idx) => {
      tab.setAttribute('aria-selected', index === idx);
    });
    // show panel
    this.dom.panels.forEach((panel, idx) => (panel.hidden = index !== idx));
  }

  handleTabKeyUp(e) {
    const tabs = Array.from(this.dom.tabs);
    const currentIndex = tabs.findIndex(tab => tab === e.currentTarget);

    if (currentIndex >= 0) {
      let newIndex;

      switch (e.keyCode) {
        case keyCode.LEFT:
          newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
          break;
        case keyCode.RIGHT:
          newIndex = (currentIndex + 1) % tabs.length;
          break;
        case keyCode.HOME:
          newIndex = 0;
          break;
        case keyCode.END:
          newIndex = tabs.length - 1;
          break;
      }

      tabs[newIndex]?.focus();
    }
  }
}

export default Module;
